import { render, staticRenderFns } from "./ShareInvoices.vue?vue&type=template&id=628c5dcd&scoped=true&"
import script from "./ShareInvoices.vue?vue&type=script&lang=js&"
export * from "./ShareInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ShareInvoices.vue?vue&type=style&index=0&id=628c5dcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c5dcd",
  null
  
)

export default component.exports